// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BrandsAndSolutionsModel } from "@guestsupply/App/Services/BrandsAndSolutionsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type BrandsAndSolutionsStateModel = {
    brandsAndSolutions: BrandsAndSolutionsModel;
    isLoading: boolean;
};

const initialState: BrandsAndSolutionsStateModel = {
    brandsAndSolutions: {},
    isLoading: false,
};

const reducer = {
    "xHeaderMenu/SetBrandsAndSolutions": (
        draft: Draft<BrandsAndSolutionsStateModel>,
        action: { brandsAndSolutions: BrandsAndSolutionsModel },
    ) => {
        draft.brandsAndSolutions = action.brandsAndSolutions;
    },
    "xHeaderMenu/StartBrandsAndSolutionsLoading": (draft: Draft<BrandsAndSolutionsStateModel>) => {
        draft.isLoading = true;
    },
    "xHeaderMenu/FinishBrandsAndSolutionsLoading": (draft: Draft<BrandsAndSolutionsStateModel>) => {
        draft.isLoading = false;
    },
};

const xBrandsAndSolutions = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xBrandsAndSolutions = xBrandsAndSolutions;

export type xBrandsAndSolutions = {
    xBrandsAndSolutions: BrandsAndSolutionsStateModel;
} & ApplicationState;

type BrandsAndSolutionsReducer = {
    brandsAndSolutions: typeof xBrandsAndSolutions;
    isLoading: typeof xBrandsAndSolutions;
};

export type BrandsAndSolutionsActions =
    | Parameters<BrandsAndSolutionsReducer[keyof BrandsAndSolutionsReducer]>[1]
    | AnyAction;
